// check if the input is valid json
import { startCase, toLower } from "lodash";

import * as Sentry from "@sentry/react";

import { IgStorage } from "./igStorage";
import { mpLogout } from "./mixpanel";

export const sleep = async (time: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, time);
  });
};

export const toProperCaseWithSpaces = (value: string) => {
  return startCase(toLower(value.replace("_", " ")));
};

export const flattenObject = (ob: object) => {
  const toReturn = {};

  Object.keys(ob).map((i) => {
    // @ts-ignore
    if (typeof ob[i] === "object" && ob[i] !== null) {
      // @ts-ignore
      const flatObject = flattenObject(ob[i]);
      Object.keys(flatObject).map((x) => {
        // @ts-ignore
        toReturn[`${i}.${x}`] = flatObject[x];
        return x;
      });
    } else {
      // @ts-ignore
      toReturn[i] = ob[i];
    }
    return i;
  });
  return toReturn;
};

export const logoutWithWorker = () => {
  let logoutWorker: SharedWorker;
  try {
    logoutWorker = new SharedWorker("./workers/logout-worker.js", {
      type: "module",
      name: "Global Logout",
    });
    logoutWorker.port.postMessage({ type: "LOG_OUT" });
  } catch (e) {
    console.log(e);
  }
};

export const Logout = () => {
  console.log("Logout Received");
  IgStorage.clearAuthTokens();
  Sentry.setUser(null);
  mpLogout();
  window.location.href = "/";
};

export const getAuthToken = () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams?.has("widgetAuth")) {
    return IgStorage.widgetToken;
  }

  if (!IgStorage.hasSessionLocalSync()) {
    logoutWithWorker();
    return null;
  }
  return urlParams?.get("auth") || IgStorage.authToken;
};
